module.exports = __webpack_public_path__ + "d74e4ded279c41eb436fc91a52c66eda.svg";